/* eslint-disable */
import { useState, useEffect } from 'react'
import { Controller } from 'react-hook-form'
import PropTypes from 'prop-types'
import { KeyboardArrowDownRounded } from '@mui/icons-material'
import StyledTextField from './StyledTextField'
import StyledAutocomplete from './StyledAutocomplete'
import WithInputLabel from './WithInputLabel'

const HHFormAutocompleteField = ({
  sx = undefined,
  name,
  control,
  disabled = false,
  label = undefined,
  placeholder = '',
  size = 'medium',
  variant = 'outlined',
  rules = undefined,
  required = false,
  fullWidth = false,
  options,
  noOptionsText,
  multiple = false,
  disableCloseOnSelect = false,
  getOptionLabel = x => x,
  isOptionEqualToValue = (option, value) => option === value,
  renderOption = undefined,
  renderTags = undefined,
  openOnFocus = false,
  loading = false,
  onChangeMiddleware = (onChange, item) => {
    onChange(item)
  },
  debug = false,
  deprecatedLabel = true,
  error = false,
  helperText = '',
  TextFieldProps = {},
  ...rest
}) => {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : ''
    document.documentElement.style.overflow = open ? 'hidden' : ''
    return () => {
      document.body.style.overflow = ''
      document.documentElement.style.overflow = ''
    }
  }, [open])

  return (
    <WithInputLabel label={deprecatedLabel && label} required={required || rules?.required === true}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={props => {
          const {
            field: { onChange, onBlur, value, ref },
          } = props
          return (
            <StyledAutocomplete
              sx={sx}
              open={debug || open}
              onBlur={() => {
                setOpen(false)
                onBlur()
              }}
              onClose={() => setOpen(false)}
              popupIcon={<KeyboardArrowDownRounded />}
              inputRef={ref}
              value={value}
              isOptionEqualToValue={isOptionEqualToValue}
              disabled={disabled}
              size={size}
              fullWidth={fullWidth}
              noOptionsText={noOptionsText}
              multiple={multiple}
              loading={loading}
              disableCloseOnSelect={disableCloseOnSelect}
              options={options}
              getOptionLabel={getOptionLabel}
              renderOption={renderOption}
              renderTags={renderTags}
              openOnFocus={openOnFocus}
              onChange={(event, item) => {
                onChangeMiddleware(onChange, item)
                if (!disableCloseOnSelect) {
                  setOpen(false)
                }
              }}
              renderInput={params => {
                return (
                  <StyledTextField
                    label={deprecatedLabel ? null : label}
                    // The popup chevron's toggle-close click bubbles up here; the open
                    // guard keeps this handler from immediately re-opening the dropdown.
                    onClick={() => {
                      if (!disabled && !open) {
                        setOpen(true)
                      }
                    }}
                    onFocus={() => {
                      if (!disabled) {
                        setOpen(true)
                      }
                    }}
                    inputRef={ref}
                    placeholder={placeholder}
                    variant={variant}
                    error={error}
                    onBlur={onBlur}
                    helperText={helperText}
                    {...params}
                    {...TextFieldProps}
                  />
                )
              }}
              {...rest}
            />
          )
        }}
      />
    </WithInputLabel>
  )
}

HHFormAutocompleteField.propTypes = {
  sx: PropTypes.object,
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  rules: PropTypes.object,
  required: PropTypes.bool,
  fullWidth: PropTypes.bool,
  options: PropTypes.array.isRequired,
  noOptionsText: PropTypes.node,
  multiple: PropTypes.bool,
  disableCloseOnSelect: PropTypes.bool,
  getOptionLabel: PropTypes.func,
  isOptionEqualToValue: PropTypes.func,
  renderOption: PropTypes.func,
  renderTags: PropTypes.func,
  openOnFocus: PropTypes.bool,
  loading: PropTypes.bool,
  onChangeMiddleware: PropTypes.func,
  debug: PropTypes.bool,
  deprecatedLabel: PropTypes.bool,
  helperText: PropTypes.string,
  TextFieldProps: PropTypes.object,
}

export default HHFormAutocompleteField
